import { Stack, Fade, Box, Button } from "@mui/material";
import { useState, useEffect, lazy, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useGetLatestWeightQuery } from "src/api/services/weightTrackerApi";
import CalculateCriteria from "../CalculateCriteria";
import { useSubmitAnswers } from "src/hooks/useSubmitAnswers";

const CalculateGraph = lazy(() => import("../CalculateGraph"));

const WeightLossProgressProjection = () => {
  const { data } = useGetLatestWeightQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const { nextQuestion } = useSubmitAnswers();
  const [switchVisual, setSwitchVisual] = useState<boolean>(false);
  const { t } = useTranslation();

  const handleNext = useCallback(() => nextQuestion(), [nextQuestion]);

  useEffect(() => {
    const visualTimeout = setTimeout(() => {
      setSwitchVisual(true);
    }, 5000);

    return () => clearTimeout(visualTimeout);
  }, []);

  if (!data) return null;

  return (
    <Stack gap="20px" onClick={handleNext} role="animated-stack">
      <Fade in={!switchVisual} unmountOnExit mountOnEnter>
        <Box>
          <CalculateCriteria patientVitals={data} />
        </Box>
      </Fade>
      <Fade in={switchVisual} timeout={1000} unmountOnExit mountOnEnter>
        <Box height="fit-content">
          <CalculateGraph patientWeight={data.weight} />
        </Box>
      </Fade>
      {switchVisual ? (
        <Button variant="contained" onClick={handleNext}>
          {t("questions.submit")}
        </Button>
      ) : null}
    </Stack>
  );
};

export default WeightLossProgressProjection;
